import type { ReleaseMember } from '../schemas/release-component';

/**
 * The page's flag table as plain data, for the reason `component-card.ts`
 * gives: vitest runs on `node`, so a label built inside the component is a label
 * no test can see.
 */

/** Spelled here, not imported from the flags feature: a node test must not load its pages. */
const TYPE_LABEL: Record<ReleaseMember['type'], string> = {
    veevart2: 'Veevart 2',
    salesforce: 'Salesforce',
};

export interface ReleaseMemberRow {
    readonly key: string;
    readonly name: string;
    readonly typeLabel: string;
    readonly defaultLabel: 'On' | 'Off';
    readonly defaultOn: boolean;
    readonly archived: boolean;
    /** Always worded as a lower bound; see {@link overridesLabel}. */
    readonly overrides: string;
}

/**
 * "At least N clients", never "N clients": the count comes from a sparse index.
 * Zero reads "None found" because "at least 0" is true of every flag and says
 * nothing.
 */
export function overridesLabel(count: number): string {
    if (count <= 0) return 'None found';
    const clients = count === 1 ? 'client' : 'clients';
    return `At least ${count.toLocaleString('en-US')} ${clients}`;
}

export function releaseMemberRows(
    members: readonly ReleaseMember[] | undefined,
): ReleaseMemberRow[] {
    return (members ?? []).map((member) => ({
        key: member.key,
        name: member.name,
        typeLabel: TYPE_LABEL[member.type],
        defaultLabel: member.enabled ? 'On' : 'Off',
        defaultOn: member.enabled,
        archived: member.archived,
        overrides: overridesLabel(member.overridesAtLeast),
    }));
}
